<template>
  <div>
    <div class="line-three">
      <div class="flex three-class">
        <div class="icon-circle flex-x-y-center">
          <div class="iconfont icon-yonghu icons"></div>
        </div>
        <div>
          <div class="my-pro">学历认证</div>
        </div>
        <div class="flex-1">
          <div class="flex-end change-password" @click="showEducation()">
            上传本人毕业证书
          </div>
        </div>
      </div>
    </div>
    <div class="line"></div>
    <el-dialog title="学历认证" :visible.sync="show_education" width="50%">
      <div class="flex-x-y-center">
        <form-create v-model="fApi" :rule="rule" :option="option"></form-create>
      </div>

      <span slot="footer" class="dialog-footer flex-x-center">
        <el-button type="primary" @click="submitForReview()"
          >提交审核</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  reqEducationCert,
  obtainQualificationInformation,
  academicCertification,
} from "@/api";
// 自定义按钮组件
formCreate.component("inputBtn", {
  data: function () {
    return {
      num: this.value,
    };
  },
  render($h) {
    if (this.num == 2) {
      return $h(
        "ElButton",
        {
          props: {
            type: "success",
            disabled: true,
            long: true,
          },
        },
        ["已审核通过"]
      );
    } else if (this.num == -1) {
      return $h(
        "ElButton",
        {
          props: {
            disabled: true,
            long: true,
          },
        },
        ["审核未通过"]
      );
    } else if (this.num == 0) {
      return $h(
        "ElButton",
        {
          props: {
            disabled: true,
            long: true,
          },
        },
        ["请填写"]
      );
    } else if (this.num == 1) {
      return $h(
        "ElButton",
        {
          props: {
            type: "info",
            disabled: true,
            long: true,
          },
        },
        ["审核中"]
      );
    }
  },
  props: {
    //预定义
    disabled: Boolean,
    value: Number,
  },
  watch: {
    value(n) {
      //同步 value 的值
      this.num = n;
    },
  },
  methods: {
    onClick1: function () {
      //调用保存借口
      this.$parent.submitForReview();
      alert("sd");
    },
  },
});

export default {
  data() {
    return {
      show_education: false,
      // 组件参数配置
      option: {
        // 显示重置表单按扭
        resetBtn: false,
        submitBtn: false,
        // 表单提交按扭事件
        //上传组件全局配置
        global: {
          upload: {
            props: {
              name: "file",
              type: "select",
              uploadType: "image",
              multiple: false,
              accept: "image/*",
              format: ["jpg", "jpeg", "png", "gif"],
              maxSize: 600,
              maxLength: 1,
              headers: {
                token: localStorage.getItem("token").replace(/\"/g, ""),
              },
              action: this.$common_upload,
              onSuccess: (file, fileList) => {
                console.log(file);
                if (file.code == 1) {
                  file.url = file.data.fullurl;
                  fileList.url = file.url;
                  return file.url;
                } else {
                  this.$message.error(file.msg);
                }

                // return response.data.url;
              },
            },
          },
        },
        onSubmit: (formData) => {
          // alert(JSON.stringify(formData));

          console.log("获取表单中的数据3：", formData);
          console.log(this.$parent.projectDetail.project_info.id);
          reqProjectSavedata({
            form_data: formData,
            project_id: this.$parent.projectDetail.project_info.id,
          }).then((res) => {
            if (res.data.code === 1) {
              //保存成功
              var temp_project_id = this.$parent.projectDetail.project_info.id;
              var temp_param = {
                project_id: temp_project_id,
                step_name: "education",
              };
              reqProjectDetail(temp_param).then((res) => {
                if (res.data.code === 1) {
                  this.changeProject(res.data.data);
                }
              });

              this.$message.success(res.data.msg);
            } else {
              this.$message.error(res.data.msg);
            }
          });
          //按钮进入提交状态
          //   this.fApi.btn.loading();

          //重置按钮禁用
          //   this.fApi.resetBtn.disabled();

          //按钮进入可点击状态
          //   this.fApi.btn.finish();
        },
      },
      // 实例对象
      fApi: {},
      rule: [
        {
          type: "el-row",
          native: true,
          children: [
            {
              type: "input", // 生成组件的名称(就是表单的名称：如input，radio，checkbox，select，slider等)
              field: "doctor_code", // 表单组件的字段名称(就是表单的name属性，注：该必须唯一),自定义组件可以不配置
              className: "user-name-dom", // 设置组件的class属性
              title: "博士学信码：", // 组件的名称, 选填
              value: "", // 表单组件的字段值(就是表单的value值),自定义组件可以不用设置
              col: {
                span: 8,
              },
            },
            {
              type: "upload", // 生成组件的名称(就是表单的名称：如input，radio，checkbox，select，slider等)
              field: "doctor_images", // 表单组件的字段名称(就是表单的name属性，注：该必须唯一),自定义组件可以不配置
              className: "user-name-dom", // 设置组件的class属性
              title: "博士学历证：", // 组件的名称, 选填
              value: "", // 表单组件的字段值(就是表单的value值),自定义组件可以不用设置
              col: {
                span: 8,
              },
            },

            {
              type: "inputBtn", // 生成组件的名称(就是表单的名称：如input，radio，checkbox，select，slider等)
              field: "doctor_status", // 表单组件的字段名称(就是表单的name属性，注：该必须唯一),自定义组件可以不配置
              className: "user-name-dom", // 设置组件的class属性
              title: " ", // 组件的名称, 选填
              value: 0,
              // 表单组件的字段值(就是表单的value值),自定义组件可以不用设置
              col: {
                span: 8,
              },
            },
          ],
        },
        {
          type: "el-row",
          native: true,
          children: [
            {
              type: "input", // 生成组件的名称(就是表单的名称：如input，radio，checkbox，select，slider等)
              field: "graduate_code", // 表单组件的字段名称(就是表单的name属性，注：该必须唯一),自定义组件可以不配置
              className: "user-name-dom", // 设置组件的class属性
              title: "研究生学信码：", // 组件的名称, 选填
              value: "", // 表单组件的字段值(就是表单的value值),自定义组件可以不用设置
              col: {
                span: 8,
              },
            },
            {
              type: "upload", // 生成组件的名称(就是表单的名称：如input，radio，checkbox，select，slider等)
              field: "graduate_images", // 表单组件的字段名称(就是表单的name属性，注：该必须唯一),自定义组件可以不配置
              className: "user-name-dom", // 设置组件的class属性
              title: "研究生学历证：", // 组件的名称, 选填
              value: "", // 表单组件的字段值(就是表单的value值),自定义组件可以不用设置
              col: {
                span: 8,
              },
            },

            {
              type: "inputBtn", // 生成组件的名称(就是表单的名称：如input，radio，checkbox，select，slider等)
              field: "graduate_status", // 表单组件的字段名称(就是表单的name属性，注：该必须唯一),自定义组件可以不配置
              className: "user-name-dom", // 设置组件的class属性
              title: " ", // 组件的名称, 选填
              value: 0,
              // 表单组件的字段值(就是表单的value值),自定义组件可以不用设置
              col: {
                span: 8,
              },
            },
          ],
        },
        {
          type: "el-row",
          native: true,
          children: [
            {
              type: "input", // 生成组件的名称(就是表单的名称：如input，radio，checkbox，select，slider等)
              field: "undergraduate_code", // 表单组件的字段名称(就是表单的name属性，注：该必须唯一),自定义组件可以不配置
              className: "user-name-dom", // 设置组件的class属性
              title: "本科学信码：", // 组件的名称, 选填
              value: "", // 表单组件的字段值(就是表单的value值),自定义组件可以不用设置
              col: {
                span: 8,
              },
            },
            {
              type: "upload", // 生成组件的名称(就是表单的名称：如input，radio，checkbox，select，slider等)
              field: "undergraduate_images", // 表单组件的字段名称(就是表单的name属性，注：该必须唯一),自定义组件可以不配置
              className: "user-name-dom", // 设置组件的class属性
              title: "本科学历证：", // 组件的名称, 选填
              value: "", // 表单组件的字段值(就是表单的value值),自定义组件可以不用设置
              col: {
                span: 8,
              },
            },

            {
              type: "inputBtn", // 生成组件的名称(就是表单的名称：如input，radio，checkbox，select，slider等)
              field: "undergraduate_status", // 表单组件的字段名称(就是表单的name属性，注：该必须唯一),自定义组件可以不配置
              className: "user-name-dom", // 设置组件的class属性
              title: " ", // 组件的名称, 选填
              value: 0,
              // 表单组件的字段值(就是表单的value值),自定义组件可以不用设置
              col: {
                span: 8,
              },
            },
          ],
        },
        {
          type: "el-row",
          native: true,
          children: [
            {
              type: "input", // 生成组件的名称(就是表单的名称：如input，radio，checkbox，select，slider等)
              field: "junior_code", // 表单组件的字段名称(就是表单的name属性，注：该必须唯一),自定义组件可以不配置
              className: "user-name-dom", // 设置组件的class属性
              title: "大专学信码：", // 组件的名称, 选填
              value: "", // 表单组件的字段值(就是表单的value值),自定义组件可以不用设置
              col: {
                span: 8,
              },
            },
            {
              type: "upload", // 生成组件的名称(就是表单的名称：如input，radio，checkbox，select，slider等)
              field: "junior_images", // 表单组件的字段名称(就是表单的name属性，注：该必须唯一),自定义组件可以不配置
              className: "user-name-dom", // 设置组件的class属性
              title: "大专学历证：", // 组件的名称, 选填
              value: "", // 表单组件的字段值(就是表单的value值),自定义组件可以不用设置
              col: {
                span: 8,
              },
            },

            {
              type: "inputBtn", // 生成组件的名称(就是表单的名称：如input，radio，checkbox，select，slider等)
              field: "junior_status", // 表单组件的字段名称(就是表单的name属性，注：该必须唯一),自定义组件可以不配置
              className: "user-name-dom", // 设置组件的class属性
              title: " ", // 组件的名称, 选填
              value: 0,
              // 表单组件的字段值(就是表单的value值),自定义组件可以不用设置
              col: {
                span: 8,
              },
            },
          ],
        },
        {
          type: "el-row",
          native: true,
          children: [
            {
              type: "input", // 生成组件的名称(就是表单的名称：如input，radio，checkbox，select，slider等)
              field: "special_code", // 表单组件的字段名称(就是表单的name属性，注：该必须唯一),自定义组件可以不配置
              className: "user-name-dom", // 设置组件的class属性
              title: "中专学信码：", // 组件的名称, 选填
              value: "", // 表单组件的字段值(就是表单的value值),自定义组件可以不用设置
              col: {
                span: 8,
              },
            },
            {
              type: "upload", // 生成组件的名称(就是表单的名称：如input，radio，checkbox，select，slider等)
              field: "special_images", // 表单组件的字段名称(就是表单的name属性，注：该必须唯一),自定义组件可以不配置
              className: "user-name-dom", // 设置组件的class属性
              title: "中专学历证：", // 组件的名称, 选填
              value: "", // 表单组件的字段值(就是表单的value值),自定义组件可以不用设置
              col: {
                span: 8,
              },
            },

            {
              type: "inputBtn", // 生成组件的名称(就是表单的名称：如input，radio，checkbox，select，slider等)
              field: "special_status", // 表单组件的字段名称(就是表单的name属性，注：该必须唯一),自定义组件可以不配置
              className: "user-name-dom", // 设置组件的class属性
              title: " ", // 组件的名称, 选填
              value: 0,
              props: [],
              // 表单组件的字段值(就是表单的value值),自定义组件可以不用设置
              col: {
                span: 8,
              },
            },
          ],
        },
      ],
      educationModel: {
        special_code: "",
        special_image: "",
        special_status: 0,
        junior_code: "",
        junior_image: "",
        special_status: 0,
        undergraduate_code: "",
        undergraduate_image: "",
        special_status: 0,
        graduate_code: "",
        graduate_image: "",
        special_status: 0,
        doctor_code: "",
        doctor_image: "",
        examine_1: "",
        submit_1: "",
      },
    };
  },
  methods: {
    submitForReview() {
      academicCertification(this.fApi.formData()).then((res) => {
        if (res.data.code === 1) {
          this.getQualificationInformation();
        } else {
        }
      });
    },

    getQualificationInformation() {
      obtainQualificationInformation().then((res) => {
        if (res.data.code === 1) {
          this.educationModel = res.data.data;
          this.fApi.setValue(this.educationModel);
          //修改表单规则
          //中专
          if (
            this.educationModel.special_status == 1 ||
            this.educationModel.special_status == 2
          ) {
            this.fApi.updateRule("special_code", {
              props: {
                disabled: true,
              },
            });
            this.fApi.updateRule("special_images", {
              props: {
                disabled: true,
                allowRemove: false,
              },
            });
          }
          //大专
          if (this.educationModel.junior_status == 1) {
            this.fApi.updateRule("junior_code", {
              props: {
                disabled: true,
              },
            });
            this.fApi.updateRule("junior_images", {
              props: {
                disabled: true,
                allowRemove: false,
              },
            });
          }
          //本科
          if (this.educationModel.undergraduate_status == 1) {
            this.fApi.updateRule("undergraduate_code", {
              props: {
                disabled: true,
              },
            });
            this.fApi.updateRule("undergraduate_images", {
              props: {
                disabled: true,
                allowRemove: false,
              },
            });
          }
          //研究生
          if (this.educationModel.graduate_status == 1) {
            this.fApi.updateRule("graduate_code", {
              props: {
                disabled: true,
              },
            });
            this.fApi.updateRule("graduate_images", {
              props: {
                disabled: true,
                allowRemove: false,
              },
            });
          }
          //博士
          if (this.educationModel.doctor_status == 1) {
            this.fApi.updateRule("doctor_code", {
              props: {
                disabled: true,
              },
            });
            this.fApi.updateRule("doctor_images", {
              props: {
                disabled: true,
                allowRemove: false,
              },
            });
          }
        }
      });
    },

    showEducation() {
      this.getQualificationInformation();
      this.show_education = true;
    },
  },
  props: {
    // 流程
  },
  mounted() {},
};
</script>
<style>
.el-row.el-row {
  margin-top: 20px;
  border-bottom: 1px solid #babdc1;
}
</style>
<style scoped></style>
